import { Stack, Switch, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 28,
    height: 16,
    padding: 0,
    display: 'flex',
    '&:active': {
        '& .MuiSwitch-thumb': {
            width: 15,
        },
        '& .MuiSwitch-switchBase.Mui-checked': {
            transform: 'translateX(9px)',
        },
    },
    '& .MuiSwitch-switchBase': {
        padding: 2,
        '&.Mui-checked': {
            transform: 'translateX(12px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: theme.palette.mode === 'dark' ? '#eeeeee' : '#e0e0e0',
            },
        },
    },
    '& .MuiSwitch-thumb': {
        boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
        width: 12,
        height: 12,
        borderRadius: 6,
        color: 'yellow',
        transition: theme.transitions.create(['width'], {
            duration: 200,
        }),
    },
    '& .MuiSwitch-track': {
        borderRadius: 16 / 2,
        opacity: 1,
        color: '#fff!important',
        backgroundColor: theme.palette.mode === 'dark' ? '#eeeeee' : '#e0e0e0',
        boxSizing: 'border-box',
    },
    '& .MuiTouchRipple-root': {
        backgroundColor: theme.palette.mode === 'dark' ? '#616161' : '#757575',
    },
    '& .Mui-checked': {
        '& .MuiTouchRipple-root': {
            backgroundColor: '#03a9f4'
        }
    }
}));

const CustomSwitch = ({ leftText, rightText, value, onClick, ...props }: any) => {
    return (
        <Stack direction="row" spacing={1} alignItems="center" {...props}>
            {leftText && <Typography component="span" onClick={onClick} sx={{cursor: 'pointer'}} >{leftText}</Typography>}
            <AntSwitch checked={value} inputProps={{ 'aria-label': 'ant design' }} onChange={onClick} />
            {rightText && <Typography component="span" onClick={onClick} sx={{cursor: 'pointer'}} >{rightText}</Typography>}
        </Stack>
    );
}

export default CustomSwitch;
